class Auth {
  constructor() {
    this.authInfo = null;
  }

  setAuth(authInfo) {
    this.authInfo = authInfo;
    localStorage.setItem('authInfo', JSON.stringify(authInfo));
  }

  getAuth() {
    return this.authInfo || JSON.parse(localStorage.getItem('authInfo'));
  }

  /**
   * 로그인/미로그인 모두에서 동작해야 함
   * - 우선순위:
   *   1) 로그인 응답의 company.primary domain
   *   2) 환경변수 REACT_APP_PUBLIC_TENANT
   *   3) 'public' (기본값)
   */
  getCompanyDomain() {
    const authInfo = this.getAuth();

    const primaryDomain = authInfo?.company?.domains?.find(
      d => d.is_primary,
    )?.domain;

    const envPublic = process.env.REACT_APP_PUBLIC_TENANT;

    return primaryDomain || envPublic || 'public';
  }

  isAuthenticated() {
    return !!this.getAuth();
  }

  isAdmin() {
    return this.getAuth()?.is_admin || false;
  }

  isManager() {
    return this.getAuth()?.is_manager || false;
  }

  isSuperuser() {
    return this.getAuth()?.is_superuser || false;
  }

  getCompany() {
    return this.getAuth()?.company;
  }

  clearAuth() {
    this.authInfo = null;
    localStorage.removeItem('authInfo');
    // URL 기반 접근 방식으로 변경됨 - selectedWarehouse 제거 로직 삭제
  }
}

export default new Auth();
